/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_1Inputs */

const en_cap_money_mock_1 = /** @type {(inputs: Cap_Money_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dental clinic, Riga`)
};

const lv_cap_money_mock_1 = /** @type {(inputs: Cap_Money_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobārstniecība, Rīga`)
};

/**
* | output |
* | --- |
* | "Dental clinic, Riga" |
*
* @param {Cap_Money_Mock_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_1 = /** @type {((inputs?: Cap_Money_Mock_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_1(inputs)
	return en_cap_money_mock_1(inputs)
});